import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IFunnelState {
  funnelDetail: IObjectState<any>
}

export const prefix = "visualization/funnel"

export const state = (): IFunnelState => ({
  funnelDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.funnelDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: IFunnelState, data) => {
    Vue.set(state, "funnelDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.funnelDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.funnelDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(state.funnelDetail, e.response?.data || e)
      )
    }
  },
}
